import { referralApi } from '@api/index';
import { useQuery } from '@hooks/useQuery';
import { QUERIES } from '@query/queries';

export const useReferralUrlQuery = () => {
  return useQuery([QUERIES.INVITE_URL], () => referralApi.getUrl());
};
